import React from 'react'
import { withFirebase } from '../../components/Fb'

// reactstrap components
import { Row, Col, Button } from 'reactstrap'
import FalconModal from '../../components/Inputs/FalconModal'
import { getValueCardSchema, getValueCardUISchema } from '../../components/Inputs/dataschemas'
// import ReactTable from 'react-table'
import ReactTable from '../../components/Lists/ReactTableWrapper'
import FalconLoading from '../../components/Inputs/FalconLoading'
import EditButton from '../../components/Buttons/EditButton'
import DeleteButton from '../../components/Buttons/DeleteButton'
import Infobox from '../../components/Infos/Infobox'


class ValueCardsContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = { loading: true, cardModalOpen: false, cards: null, images: [], venues: [] }
  }

  componentDidMount() {
    this.updateData()
    this.props.firebase.getImages().then((images) => {
      this.setState({ images })
    })
    this.props.firebase.getVenues().then((v) => {
      if (v && !v.empty) {
        this.setState({ venues: v.docs.map((doc) => ({ ...doc.data(), id: doc.id })) })
      }
    })
  }

  updateData = () => {
    const cards = []
    this.props.firebase.getValueCards().then((values) => {
      if (!values.empty) {
        let _d = values.docs
          .map((sh) => {
            return { ...sh.data(), id: sh.id }
          })
        this.setState(
          {
            raw: _d,
          },
          this.filterData
        )
      } else {
        this.setState({ raw: cards }, this.filterData)
      }
    })
  }

  handleRowSelect = (e) => {
    const _result = this.state.cards.filter((r) => r.id === e)
    this.setState({ selectedResource: _result[0] }, this.toggleCardModal)
  }

  // Stored in cents, edited in euros - both money fields, both converted back by
  // firebase._valueCardToCents on save.
  filterData = async () => {
    const data = []
    for (let i = 0; i < this.state.raw.length; i++) {
      data.push({
        ...this.state.raw[i],
        price: this.state.raw[i].price ? this.state.raw[i].price / 100 : 0,
        extra: this.state.raw[i].extra ? this.state.raw[i].extra / 100 : 0,
        actions: this.getActions(this.state.raw[i]),
      })
    }
    this.setState({ loading: false, cards: data })
  }

  deleteCard = async (id) => {
    await this.props.firebase.deleteValueCard(id)
    this.setState({ loading: true }, this.updateData)
  }

  getActions = (row) => {
    return (
      <>
        <div className='actions-right'>
          {}
          <Button
            color='danger'
            size='sm'
            onClick={(el) => {
              this.deleteCard(row.id)
            }}
          >
            <span className='btn-label'>
              <i className='nc-icon nc-simple-remove' />
            </span>
          </Button>
        </div>
      </>
    )
  }

  addNewCard = () => {
    this.setState({ selectedResource: {} }, this.toggleCardModal)
  }

  toggleCardModal = () => {
    this.setState({
      cardModalOpen: !this.state.cardModalOpen,
    })
  }


  // Two runtime lists the schema cannot carry. The images array is empty in the schema and
  // imageWidget renders whatever is in it, so without this the webshop picker opens blank; the
  // venue list comes from customers/{cid}/venues. Same shape as BenefitCardsContainer.
  getDataSchemaWithImagesList = () => {
    const schema = getValueCardSchema()
    if (this.state.images) {
      schema.dependencies.availableinshop.oneOf[0].properties.image.items.images = this.state.images
    }
    // Appended to the 'default' option the schema ships with, and stored as the venue NAME -
    // the backend lowercases it and keys the wallet path by the result.
    if (this.state.venues && this.state.venues.length > 0) {
      schema.properties.venue.oneOf = [
        { const: 'default', title: 'Oletus' },
        ...this.state.venues.filter((v) => v.name).map((v) => ({ const: v.name, title: v.name })),
      ]
    }
    return schema
  }

  createCardModal = () => {
    return (
      <FalconModal
        onUpdate={this.props.firebase.updateValueCard}
        onCreate={this.props.firebase.createValueCard}
        modifiedCallback={this.updateData}
        toggle={this.toggleCardModal}
        resource={this.state.selectedResource}
        isOpen={this.state.cardModalOpen}
        uiSchema={getValueCardUISchema()}
        dataSchema={this.getDataSchemaWithImagesList()}
        title={
          this.state.selectedResource && this.state.selectedResource.id ? 'Muokkaa arvokorttia' : 'Uusi arvokortti'
        }
        size='lg'
      />
    )
  }

  render() {
    if (this.state.loading) {
      return <FalconLoading />
    } else {
      return (
        <>
          <div className='content'>
            <Row>
              <Col>
                <Button onClick={this.addNewCard}>Lisää arvokortti</Button>
              </Col>
              <Col>
                <Infobox index={'0'}/>
              </Col>
            </Row>
            <Row>
              <Col md='12'>
                {/* ReactTableWrapper is a DataGrid wrapper: it honours columns, data, height,
                    getRowClassName, onRowClick, countTotal and noSumRow, and silently ignores
                    everything else. The react-table props this passed before - filterable,
                    noDataText, defaultFilterMethod, defaultPageSize, showPagination*, className
                    and getTdProps - all did nothing, which is why row-click editing never worked.
                    The Edit button covers that; wiring onRowClick instead would make the Delete
                    button open the editor on its way through. noSumRow is required because these
                    rows have no `sum` field and the footer would read "Summa 0.00 €". */}
                <ReactTable
                  data={this.state.cards}
                  noSumRow
                  columns={[
                    {
                      Header: 'Nimi',
                      accessor: 'name',
                    },
                    {
                      Header: 'Kuvaus',
                      accessor: 'description',
                    },
                    {
                      Header: 'Tyyppi',
                      accessor: 'type',
                      renderCell: (params) => {
                        return <span>{params.value === 'single' ? 'Yksiarvo' : 'Moniarvo'}</span>
                      }
                    },
                    {
                      Header: 'ALV',
                      accessor: 'vat',
                      renderCell: (params) => {
                        return <span>{params.value} %</span>
                      }
                    },
                    {
                      Header: 'Hinta',
                      accessor: 'price',
                      renderCell: (params) => {
                        return <span>{params.value} €</span>
                      }
                    },
                    {
                      // What the customer gets on top of what they paid. Invisible until now,
                      // and the field the cents fix was about.
                      Header: 'Lisäarvo',
                      accessor: 'extra',
                      renderCell: (params) => {
                        return <span>{params.value} €</span>
                      }
                    },
                    {
                      // An accounting boundary: a card issued at one venue may never pay at
                      // another, because they can be separate business IDs.
                      Header: 'Venue',
                      accessor: 'venue',
                      renderCell: (params) => {
                        return <span>{params.value || 'Oletus'}</span>
                      }
                    },
                    {
                      // Stored as the STRING 'true'/'false', the same convention benefit cards,
                      // memberships and proshop products use for this flag. Nothing consumes it
                      // yet - shopsync publishes no valuecards - so it records intent only.
                      Header: 'Verkkokauppa',
                      accessor: 'availableinshop',
                      renderCell: (params) => {
                        return <span>{params.value === 'true' ? 'Kyllä' : 'Ei'}</span>
                      }
                    },
                    {
                      Header: 'Muokkaa',
                      accessor: 'edit',
                      filterable: false,
                      sortable: false,
                      width: 100,
                      renderCell: (params) => {
                        return (
                          <EditButton
                            onClick={(el) => {
                              this.handleRowSelect(params.row.id)
                            }}
                          />
                        )
                      },
                    },
                    {
                      Header: 'Poista',
                      accessor: 'actions',
                      filterable: false,
                      sortable: false,
                      width: 100,
                      renderCell: (params) => {
                        return (
                          <DeleteButton
                            onClick={(el) => {
                              this.deleteCard(params.row.id)
                            }}
                          />
                        )
                      },
                    },
                  ]}
                />
              </Col>
            </Row>
            {this.state.alert}
            {this.createCardModal()}
          </div>
        </>
      )
    }
  }
}

export default withFirebase(ValueCardsContainer)
